import { aiPhotoGenerationPaidLimit } from 'reactApp/appHelpers/featuresHelpers/features/aiPhotoGeneration';
import { type AsyncValue, useAsyncValue } from 'reactApp/hooks/useAsyncValue';
import aiPhotoGenerationClamp from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.clamp';

interface NextTime {
    time: string | null;
    isTomorrow: boolean;
}

export const useNextTime = (): AsyncValue<NextTime | null> => useAsyncValue(() => aiPhotoGenerationClamp.getNextTime(), null, []);

export const useAttemptsLeft = (): AsyncValue<number> =>
    useAsyncValue(() => aiPhotoGenerationClamp.getAttemptsLeft(), aiPhotoGenerationPaidLimit, []);
